import React from 'react'

const UTalca = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 129.37 129.3"
      {...props}>
      <title>Universidad de Talca</title>
      <g>
        <path
          d="M0,0H129.31V38.8H0ZM97.36,129.27l-65,0A32.36,32.36,0,0,1,.07,97L0,47.54H43V97H86.33V47.54h43V94.89c0,.68.06,1.37.06,2.06A32.33,32.33,0,0,1,97.36,129.27Z"
          fill="#a41e2e"
        />
      </g>
    </svg>
  )
}

export default UTalca
